// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2e-mM","cell":"ColumnAccessor_cell__2z80y","firstCellAccent":"ColumnAccessor_firstCellAccent__3pe5F"};